import SampleReportView from "@/components/samples/SampleReportView";
import { FREEDOM_POWER_REPORT } from "@/data/sample-reports";

const FreedomPowerSample = () => <SampleReportView report={FREEDOM_POWER_REPORT} />;

export default FreedomPowerSample;
